export enum ClassAssignment {
    Direct = 'Direct',
    Course = 'Course',
    Group = 'Group',
    ClassLink = 'ClassLink',
    Clever = 'Clever',
    AzureAdGroup = 'AzureAdGroup'
  }
